
const Inscripto = (props) => {
  const formato_cajon_visible = "flex flex-row justify-around my-1 visible"
  const formato_cajon_invisible = "flex flex-row justify-around my-1 invisible"
  const formato_data_visible = "flex flex-row justify-between visible"
  const formato_data_invisible = "flex flex-row justify-between invisible"

  const generar_QR = (() => {
    fetch(props.back + 'admin/armar_certificadoqr', {
      body: JSON.stringify(props.updData),
      method: 'POST',
      headers: { 'Authorization': 'Bearer ' + props.token, 'Content-Type': 'application/json' }
    })
      .then(response => response.json())
      .then(a => {
        console.log(a.resp)
        if (a.resp)
          window.open("https://inscripcion.ar/servicios/back_" + props.evento.tabla + "/tarjetas/" + props.evento.prefijoqr + props.updData.id + '.png')
      })
  })

  const comprobante = () => {
    window.open("https://inscripcion.ar/servicios/back_" + props.evento.tabla + "/uploads/" + props.evento.prefijoqr + props.updData.id + '.png')
  }



  const update = (() => {
    const ape = props.updData.apellido.length ? props.updData.apellido[0].toUpperCase() + props.updData.apellido.slice(1) : ''
    const nom = props.updData.nombre.length ? props.updData.nombre[0].toUpperCase() + props.updData.nombre.slice(1) : ''
    const a = { ...props.updData, apellido: ape, nombre: nom }
    var data = {
      body: JSON.stringify(a),
      method: 'POST',
      headers: { 'Authorization': 'Bearer ' + props.token, 'Content-Type': 'application/json' }
    }

    fetch(props.back + 'admin/corregir', data)
      .then(response => response.json())
      .then(json => {
        if (json.success) {

          props.setPreinscriptos(props.preinscriptos.map(a => a.id === props.updData.id ? json.data : a))
          props.setUpdData({ id: 0 })
        } else {
          alert('Documento repetido')
        }
      })
  })

  const restric = [
    { cartel: 'Ninguna' },
    { cartel: 'Celíaco' },
    { cartel: 'Vegano' },
    { cartel: 'Vegetariano' },
    { cartel: 'Hipertenso' },
    { cartel: 'Otra' }
  ]

  const opciones = restric.map((a, i) => {
    return <option className='text-sm' value={a.cartel} key={i}>{a.cartel}</option>
  })


  return (<>
    <div className="border-2 border-gray-600 w-full my-1 px-2 flex flex-col mb-10 bg-zinc-400">
      <div className="flex flex-row justify-evenly my-1">
        <div className="flex flex-row justify-between">
          <label>Apellido</label>
          <input
            type="text"
            value={props.updData.apellido}
            onChange={e => props.setUpdData({ ...props.updData, apellido: e.target.value })}
            className="ml-5"
          />
        </div>
        <div className="flex flex-row justify-between">
          <label>Nombre</label>
          <input
            type="text"
            value={props.updData.nombre}
            onChange={e => props.setUpdData({ ...props.updData, nombre: e.target.value })}
            className="ml-5"
          />
        </div>
        {console.log(props.updData)}
        <div className="flex flex-row justify-between w-30">
          <label>Mail</label>
          <input
            type="text"
            value={props.updData.email ?? ''}
            onChange={e => props.setUpdData({ ...props.updData, email: e.target.value })}
            className="ml-5"
          />
        </div>
        <div className="flex flex-row justify-between w-30">
          <label>Documento</label>
          <input
            type="text"
            value={props.updData.documento}
            onChange={e => props.setUpdData({ ...props.updData, documento: e.target.value })}
            className="ml-5"
          />
        </div>
      </div>
      <div className="flex flex-row justify-evenly my-1">
        <div className="flex flex-row justify-between w-30">
          <label>Cliente</label>
          <input
            type="text"
            value={props.updData.cliente}
            onChange={e => props.setUpdData({ ...props.updData, cliente: e.target.value })}
            className="ml-5"
          />
        </div>
        <div className="flex flex-row justify-between w-30">
          <label>Inscripto</label>
          <select
            className='px-2 ml-5'
            value={props.updData.inscripto}
            onChange={e => props.setUpdData({ ...props.updData, inscripto: e.target.value })}
          >
            <option value="true">Si</option>
            <option value="false">No</option>
          </select>
        </div>
        <div className="flex flex-row justify-between w-30">
          <label>Acompañante</label>
          <select
            className='px-2 ml-5'
            value={props.updData.acomp}
            onChange={e => props.setUpdData({ ...props.updData, acomp: e.target.value })}
          >
            <option value="true">Si</option>
            <option value="false">No</option>
          </select>
        </div>
      </div>
      <div className="flex flex-row justify-evenly my-1">
        <div className="flex flex-row justify-between w-30">
          <label>Observaciones</label>
          <input
            type="text"
            value={props.updData.obs || ''}
            onChange={e => props.setUpdData({ ...props.updData, obs: e.target.value })}
            className="ml-5"
          />
        </div>
        <div className="flex flex-row justify-between w-30">
          <label>Cartones</label>
          <input
            type="text"
            value={props.updData.carton || ''}
            onChange={e => props.setUpdData({ ...props.updData, carton: e.target.value })}
            className="ml-5 "
          />
        </div>
        <div className="flex flex-row justify-between w-30">
          <label>Cartones Válidos</label>
          <input
            type="text"
            value={props.updData.carton_valido || ''}
            onChange={e => props.setUpdData({ ...props.updData, carton_valido: e.target.value })}
            className="ml-5 "
          />
        </div>
        <div className="flex flex-row justify-between w-30">
          <label>Mesa</label>
          <input
            type="text"
            value={props.updData.mesa || ''}
            onChange={e => props.setUpdData({ ...props.updData, mesa: e.target.value })}
            className="ml-5 w-12"
          />
        </div>
        <div className="flex flex-row justify-between w-30">
          <label>Restriccion</label>
          <select
            className='px-2 ml-5'
            value={props.updData.restriccion}
            onChange={e => props.setUpdData({ ...props.updData, restriccion: e.target.value })}
          >
            {opciones}
          </select>
        </div>
        <div className="flex flex-row justify-between w-30">
          <label>Expositor</label>
          <select
            className='px-2 ml-5'
            value={props.updData.expositor}
            onChange={e => props.setUpdData({ ...props.updData, expositor: e.target.value })}
          >
            <option value="true">Si</option>
            <option value="false">No</option>
          </select>
        </div>
        <div className={props.updData.id ? formato_data_visible : formato_data_invisible}>
          <label className="font-lg">{'ID:  ' + props.evento.prefijoqr + (props.updData.id).toString().padStart(4, '0')}</label>
        </div>
      </div>
      {props.updData.expositor ? (<>
        <div className="flex flex-row justify-evenly my-1">
          <div className="flex flex-row justify-between">
            <label>Teléfono</label>
            <input
              type="text"
              value={props.updData.telefono}
              onChange={e => props.setUpdData({ ...props.updData, telefono: e.target.value })}
              className="ml-5"
            />
          </div>

          <div className="flex flex-row justify-between">
            <label>Empresa</label>
            <input
              type="text"
              value={props.updData.empresa}
              onChange={e => props.setUpdData({ ...props.updData, empresa: e.target.value })}
              className="ml-5"
            />
          </div>
        </div>
      </>)
        : ''}
      {props.updData.acomp ? (<>
        <div className="flex flex-row justify-evenly my-1">
          <div className="flex flex-row justify-between w-30">
            <label>Pago Acomp</label>
            <select
              className='px-2 ml-5'
              value={props.updData.pago_estado}
              onChange={e => props.setUpdData({ ...props.updData, pago_estado: e.target.value })}
            >
              <option value="aprobado">Aprobado</option>
              <option value="pendiente">Pendiente</option>
            </select>
          </div>
          <div className="flex flex-row justify-between">
            <label>Apellido Acomp</label>
            <input
              type="text"
              value={props.updData.apellido_acomp}
              onChange={e => props.setUpdData({ ...props.updData, apellido_acomp: e.target.value })}
              className="ml-5"
            />
          </div>
          <div className="flex flex-row justify-between">
            <label>Nombre Acomp</label>
            <input
              type="text"
              value={props.updData.nombre_acomp}
              onChange={e => props.setUpdData({ ...props.updData, nombre_acomp: e.target.value })}
              className="ml-5"
            />
          </div>
          <div className="flex flex-row justify-between">
            <label>Restriccion Acomp</label>
            <select
              className='px-2 ml-5'
              value={props.updData.restriccion_acomp}
              onChange={e => props.setUpdData({ ...props.updData, restriccion_acomp: e.target.value })}
            >
              {opciones}
            </select>
          </div>
        </div>
      </>)
        : ''}
      <div className="flex flex-row justify-evenly my-1">

        {props.updData.cuando &&
          <div className={props.updData.id ? formato_data_visible : formato_data_invisible}>
            <label className="font-lg">Registrado el {props.updData.cuando.substr(0, props.updData.cuando.indexOf('T'))}</label>
            <label className="fornt-lg ml-3">A las  {props.updData.cuando.substr(props.updData.cuando.indexOf('T') + 1, 8)}</label>
          </div>
        }
      </div>
      <div className={props.updData.id ? formato_cajon_visible : formato_cajon_invisible}>
        {(props.quien.rol === 2 || props.quien.permisos & 2) && props.acomp ?
          <button
            name='Comprobante'
            className="border-2 px-2 border-blue-400 bg-blue-200 text-sm hover:text-white hover:bg-blue-800"
            onClick={() => update()}
          >
            Ver Comporbante
          </button>
          : ''}
        {(props.quien.rol === 2 || props.quien.permisos & 2) ?
          <button
            name='Aceptar'
            className="border-2 px-2 border-blue-400 bg-blue-200 text-sm hover:text-white hover:bg-blue-800"
            onClick={() => update()}
          >
            Guardar Cambios
          </button>
          : ''}
        {(props.quien.rol === 2 || props.quien.permisos & 16) ?
          <button
            name='Generar'
            className="border-2 px-2 border-green-400 bg-green-200 text-sm hover:text-white hover:bg-blue-800"
            onClick={e => generar_QR()}
          >
            Ver QR
          </button>
          : ''}
      </div>
    </div>
  </>)
}


export default Inscripto